import {  LoanControllerApi } from 'client';

export const useBannerServices = () => {
	const services = new LoanControllerApi();

	const getBanner = (): Promise<any> => {
		return services.fetchBannerUsingGET();
	};
	return { getBanner } as const;
};
